export default __webpack_public_path__ + "static/media/56_desktop.1e7ccdbf.jpg";